import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { FavoritesServiceRB } from 'rainbow-web-sdk/services/favorites/favorites.service';

export class FavoritesPlugin extends Plugin {
    public static initialize(): FavoritesPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[FavoritesPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[FavoritesPlugin] initialized");
            window.rainbow.plugins[FavoritesPlugin.name] = new FavoritesPlugin();
            FavoritesServiceRB.getInstance();
        }
        return window.rainbow.plugins[FavoritesPlugin.name];
    }

    private constructor() {
        super();
    }
}
